"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var saveToDisk_1 = require("../../../../../common/helpers/saveToDisk");
var time_1 = require("../../../../../common/helpers/time");
var AdminStudentReportCardsController = /** @class */ (function () {
    function AdminStudentReportCardsController($stateParams, UsersModel, reportcards, student) {
        this.$stateParams = $stateParams;
        this.reportcards = [];
        this.printing = false;
        this.totalItems = reportcards.total;
        this.currentPage = reportcards.current_page;
        this.reportcards = reportcards.data.map(function (reportcard) {
            return reportcard;
        });
        this.page_by = reportcards.per_page;
        this.pageChanged = this.pageChanged.bind(this);
        this.loading = false;
        this.student = student;
        this.UsersModel = UsersModel;
        this.student = student;
        this.pageChanged = this.pageChanged.bind(this);
        this.print = this.print.bind(this);
    }
    AdminStudentReportCardsController.prototype.pageChanged = function () {
        var _this = this;
        this.UsersModel.getStudentReportcards({
            id: this.student.id,
            page: this.currentPage,
            page_by: 20,
        }).then(function (response) {
            _this.reportcards = response.reportcards.data.map(function (reportcard) {
                return reportcard;
            });
            _this.totalItems = response.reportcards.total;
            _this.page_by = response.reportcards.per_page;
            _this.currentPage = response.reportcards.current_page;
        });
    };
    AdminStudentReportCardsController.prototype.formatStartDateTime = function (reportcard) {
        return (0, time_1.dateTimeStringToDate)(reportcard.drive.drive_date + " " + reportcard.drive.start_time).toLocaleDateString("en-US");
    };
    AdminStudentReportCardsController.prototype.driveDate = function (reportcard) {
        if (!reportcard.drive || !reportcard.drive.drive_date) {
            return null;
        }
        try {
            return (0, time_1.dateStringToDate)(reportcard.drive.drive_date);
        }
        catch (e) {
            return null;
        }
    };
    AdminStudentReportCardsController.prototype.print = function () {
        var _this = this;
        this.printing = true;
        this.UsersModel.printStudentReportcards({ id: this.$stateParams.userId })
            .then(function (response) {
            _this.printing = false;
            (0, saveToDisk_1.saveToDisk)(response.file.url, response.file.name);
        })
            .catch(function (Error) {
            _this.printing = false;
        });
    };
    return AdminStudentReportCardsController;
}());
AdminStudentReportCardsController.$inject = [
    "$stateParams",
    "UsersModel",
    "reportcards",
    "student",
];
exports.default = AdminStudentReportCardsController;
